import React from 'react';
import { UserApi } from 'api';
import { useAuthContext } from 'hooks/useAuthContext';
import { ChangeEvent, FormEvent, useState } from 'react';
import { useClickStreamContext } from '../ClickStream';
import {
  Fields,
  FormWrapper,
  HelpWrapper,
  LoginTitle,
  SubmitButton,
  SubmitWrapper,
  Link,
  AccessRequest,
} from './elements';

import Input from '@gr-monorepo/common/ui/Input';
import { Space } from '@gr-monorepo/common/ui';
import LoginLoader from '../LoginLoader';
export const MINISTER_USER_TYPE = 'ministr';
const useLoginForm = () => {
  const [formData, setFormData] = useState<{ login: string; password: string; error: string }>({
    login: '',
    password: '',
    error: '',
  });
  const [pending, setPending] = useState(false);
  const { fetchUserData } = useAuthContext();

  const submitForm = async () => {
    setPending(true);
    const data = {
      login: formData.login,
      password: formData.password,
      user_type: MINISTER_USER_TYPE,
    };

    try {
      await UserApi.login({ data });
      setPending(true);
      localStorage.setItem('UPR_logged', 'true');
      fetchUserData();
      setFormData({ ...formData, error: '' });
    } catch (err: any) {
      console.log(err.status === 401);
      setFormData({ ...formData, error: err.status === 401 ? 'Неправильный логин или пароль!' : 'Ошибка входа' });
      setPending(false);
    }
  };
  return { formData, setFormData, submitForm, pending };
};
const LoginForm = () => {
  const { formData, setFormData, submitForm, pending } = useLoginForm();
  const { logPageEvent } = useClickStreamContext();
  const handleLogin = (value: string) => {
    setFormData({ ...formData, error: '', login: value });
  };
  const handlePassword = (value: string) => {
    setFormData({ ...formData, error: '', password: value });
  };
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    logPageEvent({
      eventType: 'login_submit',
      eventInfo: `Клик по кнопке авторизации в форме логина`,
      eventSource: 'login_municipality',
    });
    if (!formData.login || !formData.password) {
      setFormData({ ...formData, error: 'Укажите логин и пароль' });
      return;
    }
    submitForm();
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <LoginTitle>Вход в кабинет</LoginTitle>
      <Fields>
        <Input
          placeholder="Логин"
          inputProps={{ type: 'text' }}
          value={formData.login}
          onChange={handleLogin}
          error={!!formData.error}
          style={{
            borderColor: !formData.error ? 'rgba(9, 21, 38, 0.6)' : undefined,
            fontSize: 18,
            lineHeight: '24px',
            padding: 10,
          }}
          dataQaId="input_login"
        />
        <Space size={46} axis="vertical" style={{ position: 'relative', width: '100%' }}>
          {pending && (
            <LoginLoader style={{ position: 'absolute', left: '50%', transform: 'translate(-50%)', top: 11 }} />
          )}
        </Space>

        <Input
          placeholder="Пароль"
          inputProps={{ type: 'password' }}
          value={formData.password}
          onChange={handlePassword}
          error={!!formData.error}
          errorText={formData.error}
          style={{
            borderColor: !formData.error ? 'rgba(9, 21, 38, 0.6)' : undefined,
            fontSize: 18,
            lineHeight: '24px',
            padding: 10,
          }}
          dataQaId="input_password"
        />
      </Fields>
      <SubmitWrapper>
        <SubmitButton disabled={pending} data-qa-id="button_login">
          {'Войти'}
        </SubmitButton>
      </SubmitWrapper>
      <Space size={12} axis="vertical" />
      <AccessRequest
        onClick={() => {
          logPageEvent({
            eventType: 'click_mailto_support',
            eventInfo: `Клик по ссылке электронной почты саппорта`,
            eventSource: 'login_municipality',
          });
        }}
        href="https://upr-dostup.uchi.ru/"
        data-qa-id="button_registration"
      >
        Подать заявку на регистрацию
      </AccessRequest>
      <Space size={24} axis="vertical" />
      <HelpWrapper style={{ marginRight: -10 }}>
        Если у вас возникли трудности со входом, свяжитесь с нами{' '}
        <Link
          onClick={() => {
            logPageEvent({
              eventType: 'click_mailto_support',
              eventInfo: `Клик по ссылке электронной почты саппорта`,
              eventSource: 'login_municipality',
            });
          }}
          href="mailto: support_kabmun-uchi@vk.team"
          data-qa-id="support_mail"
        >
          support_kabmun-uchi@vk.team
        </Link>
      </HelpWrapper>
      <Space size={12} axis="vertical" />
      <HelpWrapper style={{ marginRight: -30 }}>
        Если вы <span style={{ fontWeight: 'bold' }}>ученик</span> или{' '}
        <span style={{ fontWeight: 'bold' }}>учитель</span> зайдите в личный кабинет по ссылке:{' '}
        <Link
          onClick={() => {
            logPageEvent({
              eventType: 'click_go_to_uchi',
              eventInfo: `Клик по ссылке главная учиру`,
              eventSource: 'login_municipality',
            });
          }}
          href="https://uchi.ru/"
          data-qa-id="uchiru_link"
        >
          https://uchi.ru/
        </Link>
      </HelpWrapper>
    </FormWrapper>
  );
};

export default LoginForm;
